import React, { useState } from 'react'


interface Props {
  className: string
}
const RegisterButton: React.FC<Props> = ({ children, className }) => {
  const loginUrl = `${process.env.NEXT_PUBLIC_API_URL}connect/github`;
  return (
    <a href={loginUrl} id="register-btn">
      <div className={className}>
        {children}
      </div>
    </a>
  )
}


export default RegisterButton;